import React from "react"
import { Card, CardBody, Col } from "reactstrap"

function Header() {
  return (
    <Card className="mb-0">
      <CardBody className="py-3">
        <Col>
          <div className="float-start">
            <h5 className="text-primary mb-1">LLM Instruction Tuning</h5>
            <p className="text-muted small mb-0">
              Set the extra instruction the appointment-response LLMs follow for one customer
              and location, and see what it changes before you save it.
            </p>
          </div>
        </Col>
      </CardBody>
    </Card>
  )
}

export default Header
